import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@components/common';

export const AcessoNegado: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-8 bg-base-200">
      <div className="card bg-base-100 shadow-xl max-w-md w-full text-center">
        <div className="card-body">
          <h1 className="text-8xl font-bold text-error mb-4">403</h1>
          <h2 className="text-3xl font-semibold text-base-content mb-4">Acesso Negado</h2>
          <p className="text-lg text-base-content/70 mb-8">
            Você não tem permissão para acessar esta página.
          </p>
          <div className="flex gap-4 justify-center">
            <Button onClick={() => navigate(-1)} variant="secondary">
              Voltar
            </Button>
            <Button onClick={() => navigate('/')} variant="primary">
              Ir para Início
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
